import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeActionPersistence } from "../actionPersistence";
export var epicPersistenceWriteBeforeAction = function (action$) {
    return action$.pipe(ofType(TypeActionPersistence.WriteBeforeAction), switchMap(function (action) {
        utilPersistence.setValue(action.persistenceId, action.value, action.persistenceMode);
        return of(action.action);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/persistence/epic/epicPersistenceWriteBeforeAction.ts
// module id = 2039
// module chunks = 3